import "bootstrap/dist/js/bootstrap.bundle.min.js";

sal({
  // once: false
});

// :hover, .hover
document.querySelectorAll(".js_h").forEach((jsh) => {
  ["mouseenter", "touchstart"].forEach((event) => {
    jsh.addEventListener(event, () => {
      jsh.classList.add("hover");
    });
  });
  ["mouseleave", "touchend"].forEach((event) => {
    jsh.addEventListener(event, () => {
      jsh.classList.remove("hover");
    });
  });
});

// スクロールが100に達したらページの先頭に戻るボタン表示
var ywsa = document.getElementById("page-top");
var yws_pagetop = function () {
  if (window.pageYOffset > 100) {
    ywsa.classList.add("fixed");
  } else {
    ywsa.classList.remove("fixed");
  }
};
// ページ内スムーススクロール
window.addEventListener("load", yws_pagetop);
window.addEventListener("scroll", yws_pagetop);
ywsa.addEventListener("click", (e) => {
  e.preventDefault();
  window.scroll({
    top: 0,
    behavior: "smooth",
  });
});

// overseas common header
// let currentPosition = 0;

// const header = document.querySelector(".overseas-common-header");
// const headerHeight = header.clientHeight * -1;

// window.addEventListener("scroll", () => {
//   let scrollPosition = document.documentElement.scrollTop;

//   if (currentPosition <= scrollPosition) {
//     header.classList.add("backdrop");
//   } else if (currentPosition > scrollPosition) {
//     header.classList.remove("backdrop");
//   }
//   currentPosition = document.documentElement.scrollTop;
// });

const header = document.querySelector(".overseas-common-header");
const headerHeight = header.clientHeight;
let prevY = window.scrollY;

window.addEventListener("scroll", () => {
  const currentY = window.scrollY;
  //  if (currentY < prevY) {
  if (currentY < headerHeight) {
    header.classList.remove("backdrop");
  } else {
    if (currentY > 0) {
      header.classList.add("backdrop");
    }
  }
  prevY = currentY;
});

// IntersectionObserver
document.addEventListener("DOMContentLoaded", function () {
  const headings = document.querySelectorAll(".heading");

  const options = {
    threshold: 1,
  };

  const observer = new IntersectionObserver(showElements);

  headings.forEach((heading) => {
    observer.observe(heading);
  });

  // 要素が表示されたら実行する動作
  function showElements(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // 各 .heading に .active を加える
        entry.target.classList.add("active");
      }
    });
  }

  // floating menu
  if (document.querySelector(".floating-menu")) {
    const nav = document.querySelector(".floating-menu");

    window.addEventListener("load", function () {
      //  ページを読み込み終わったら実行する処理;
      setTimeout(function () {
        nav.classList.add("opend");
      }, 500);
    });
  }
});
